import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'disableOffers',
  initialState: false,
  reducers: {
    setDisableOffers(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisableOffers } = slice.actions;

export default slice.reducer;
